import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.listUsers || initialState;

export const selectListUsers = createSelector(
  [selectSlice],
  state => state.listUsers,
);
